import { FC } from 'react';
import { useFormContext } from 'react-hook-form';
import { Spacer } from 'jbc-front/components/presenters/Spacer';
import { Label } from 'jbc-front/components/presenters/form/Label';
import { Input } from 'jbc-front/components/presenters/form/Input';
import { ErrorMessage } from 'jbc-front/components/presenters/form/ErrorMessage';
import { Headding, Item, Panel } from '@/components/PrimaryPanel';
import type { Schema } from '../../schema';

export const Physician: FC = () => {
  const {
    register,
    formState: { errors }
  } = useFormContext<Schema>();

  return (
    <Panel>
      <Headding>産業医</Headding>
      <Item>
        <div>
          <Label>氏名</Label>
          <Spacer size={8} />
          <Input {...register(`physicianName`)} />
          {errors.physicianName?.message && <ErrorMessage>{errors.physicianName.message}</ErrorMessage>}
        </div>
        <Panel className="u-mt20">
          <Headding>所属機関</Headding>
          <Item>
            <div>
              <Label>所属機関名</Label>
              <Spacer size={8} />
              <Input {...register(`physicianInstitutionName`)} />
              {errors.physicianInstitutionName?.message && (
                <ErrorMessage>{errors.physicianInstitutionName.message}</ErrorMessage>
              )}
            </div>
            <div className="u-mt20">
              <Label>所在地</Label>
              <Spacer size={8} />
              <Input {...register(`physicianInstitutionAddress`)} />
              {errors.physicianInstitutionAddress?.message && (
                <ErrorMessage>{errors.physicianInstitutionAddress.message}</ErrorMessage>
              )}
            </div>
          </Item>
        </Panel>
      </Item>
    </Panel>
  );
};
